var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('div',{class:_vm.b('name')},[_vm._v(_vm._s(_vm.debtor.name)+" ("),_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm.debtor.vatType))]),_vm._v(": "+_vm._s(_vm.debtor.vat)+")")])])
}
var staticRenderFns = []

export { render, staticRenderFns }